import { LANDING_PAGE_ROUTE } from "config/route-consts";
import { PrivateRoute } from "pages/Authentication/PrivateRoute";
import ForbidentView from "pages/ForbidentView/ForbidentView";
import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import LandingPageView, {
  DecodeToken,
} from "views/LandingPageView/NewLandingPage";
import WebFont from "webfontloader";
import "./i18n/i18n";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import * as Cookie from "js-cookie";
import jwtDecode from "jwt-decode";
import { LOGIN_SSO_WAITING_PAGE } from "config/route-consts";
import moment from "moment";
import LoginSSOWaitingPage from "pages/Authentication/Login/LoginSSOWaitingPage";
import Login from "pages/Authentication/Login/Login";
// import LoginSSOWaitingPage from "pages/Authentication/Login/LoginSSOWaitingPage";

WebFont.load({
  google: {
    families: ["Inter"],
  },
});

const app = (
  <Fragment>
    <Provider store={store}>
      {/* <SignalRContext.Provider value={signalRService}> */}
      <React.Suspense fallback={null}>
        <BrowserRouter basename="/">
          <Switch>
            <Route
              exact
              path={LOGIN_SSO_WAITING_PAGE}
              component={LoginSSOWaitingPage}
            />
            <Route
              exact
              path={`/login`}
              render={() => {
                if (
                  Cookie.get("access_token") &&
                  jwtDecode<DecodeToken>(Cookie.get("access_token")).exp >
                    moment.now() / 1000
                ) {
                  return <Redirect to={LANDING_PAGE_ROUTE} />;
                } else {
                  return <Login />;
                }
              }}
            />
            <Route exact path={`/403`} component={ForbidentView} />
            <Route
              exact
              path={LANDING_PAGE_ROUTE}
              component={LandingPageView}
            />
            <PrivateRoute path="/" />
          </Switch>
        </BrowserRouter>
      </React.Suspense>
      {/* </SignalRContext.Provider> */}
    </Provider>
  </Fragment>
);

ReactDOM.render(app, document.getElementById("root"));
serviceWorker.unregister();
